import { reportModalCtaClick } from '../../../bi/bi';
import { Modals } from '../../../types';
import { useModals } from '../../../context/ModalsContext';
import { useInstallerContext } from '../../../context/InstallerContext';
export const useConsentModalOnClicks = () => {
  const {
    modals
  } = useModals();
  const {
    preInstallationData: {
      isAppAlreadyInstalled
    }
  } = useInstallerContext();
  const onAgreeButtonClick = () => {
    reportModalCtaClick({
      ctaName: isAppAlreadyInstalled ? 'agree-and-update' : 'agree-and-add',
      modalType: Modals.userConsent
    });
    modals.userConsent.close({
      answer: 'PROCEED'
    });
  };
  const onCloseButtonClick = () => {
    reportModalCtaClick({
      ctaName: 'close',
      modalType: Modals.userConsent
    });
    modals.userConsent.close({
      answer: 'CANCELED'
    });
  };
  return {
    onAgreeButtonClick,
    onCloseButtonClick
  };
};
//# sourceMappingURL=useConsentModalOnClicks.js.map